module.exports = __webpack_public_path__ + "img/4.2d7e236e.png";